import React, { useEffect, useRef, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { analyzeRecording } from '../../../../actions/EpikBoxes';
import AnalyzingIcon from '../../../../Res/Icon/analyzing.png';
import AnalyzingEnhancedIcon from '../../../../Res/Icon/analysis-enhanced.svg';
import PauseIcon from '../../../../Res/Icon/pause.png';
import PlayIcon from '../../../../Res/Icon/play.png';
import RestartIcon from '../../../../Res/Icon/restart.png';
import ZoomIn from '../../../../Res/Icon/zoomin.png';
import ZoomOut from '../../../../Res/Icon/zoomout.png';
import analyzingLoading from '../../../../Res/Icon/analyzeLoading.svg';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import WaveSurfer from "wavesurfer.js";
import { useUnifiedFetch } from '../../../../hooks';
import { getPermissionForComponent } from '../../../../utils/permissionsUtils';


const AnalyzerModal = ({ isOpen, onClose, file, note }) => {
    const token = localStorage.getItem('jwtToken');
    const dispatch = useDispatch();
    const [data, setData] = useState(null);
    const [zoom, setZoom] = useState(1);
    const [showDetails, setShowDetails] = useState(false);
    const waveformRef = useRef();

    const {
        isLoading: isFetchingBoxAnalyzer,
        data: boxAnalyzer,
        fetchData: fetchBoxCallAnalyzer
      } = useUnifiedFetch(`boxes/notes/${note._id}/analyze`, false);

    const user = useSelector(state => state.AppState.user);

    const enhancedAnalyzer = getPermissionForComponent('enhancedAnalyzer',user.permissionsGroup);

    useEffect(() => {
        setFile();
        return () => {
            if (window.wavesurfer) {
                try {
                    window.wavesurfer.pause();
                } catch (e) {
                    console.warn('Error pausing wavesurfer:', e);
                }
                window.wavesurfer = null;
            }
        }
    }, []);
    const setFile = async () => {
        let fileBuffer;
        let fileToUse = file;
        if (typeof file === 'string') {
            // If file is a string (URL/path), fetch it and convert to Blob
            try {
                const response = await fetch(file);
                fileToUse = await response.blob();
            } catch (e) {
                toast.error('Failed to fetch audio file.');
                return;
            }
        }
        if (fileToUse && typeof fileToUse.arrayBuffer === 'function') {
            fileBuffer = await fileToUse.arrayBuffer();
        } else {
            toast.error('Invalid audio file.');
            return;
        }
        const reader = new FileReader();
        reader.readAsArrayBuffer(fileToUse);
        if (waveformRef.current) {
            window.wavesurfer = WaveSurfer.create({
                container: waveformRef.current,
                splitChannels: true,
                splitChannelsOptions: {
                    overlay: false,
                    channelColors: {
                        0: {
                            progressColor: 'green',
                            waveColor: 'blue'
                        },
                        1: {
                            progressColor: 'green',
                            waveColor: 'blue'
                        }
                    }
                }
            });
            console.log({ loaded: "as" })
            window.wavesurfer.loadBlob(fileToUse);
        }
    };
    const pause = () => {
        window.wavesurfer.pause();
    };
    const play = () => {
        window.wavesurfer.play();
    };
    // const restart = () => {
    //     wavesurfer.currentTime = 0;
    //     window.audio.play();
    // };
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingFor, setIsLoadingFor] = useState('');
    
    const analyze = async (type) => {
        setIsLoading(!isFetchingBoxAnalyzer);
        setIsLoadingFor(type)

        const res = await fetchBoxCallAnalyzer({ type });

        console.log(res);
        setData(res);
        setIsLoading(isFetchingBoxAnalyzer);
        setIsLoadingFor('')

        if (!res?.status && res?.message) {
            toast.error(res?.message);
        }
    };

    useEffect(() => {
        if (window.wavesurfer)
            window.wavesurfer.zoom(zoom)
    }, [zoom])
    return (
        <Modal isOpen={isOpen} className="create-box-modal">
            <ModalHeader>Analyzer</ModalHeader>
            <ModalBody>
                <div className="container">
                    <Row>
                        <Col md={1} style={{ display: "flex", justifyContent: "space-evenly", flexDirection: "column" }} >
                            <p >From Epik Edge</p>
                            <hr />
                            <p >From Monitoring Station</p>
                        </Col>
                        <Col md={10} style={{ overflowX: "scroll", borderRadius: 5, borderColor: "blue", borderWidth: 2 }}>
                            <div style={{ width: '100%' }} ref={waveformRef}></div>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: 50 }}>
                        <Col md={1}>
                            <img onClick={pause} style={{ height: '20px', cursor: 'pointer' }} src={PauseIcon} alt="..." />
                        </Col>
                        <Col md={1}>
                            <img onClick={play} style={{ height: '20px', cursor: 'pointer' }} src={PlayIcon} alt="..." />
                        </Col>
                        {/* <Col md={1}>
                            <img onClick={restart} style={{ height: '20px' }} src={RestartIcon} alt="..." />
                        </Col> */}
                        <Col md={1}>
                            <img style={{ height: '20px', cursor: 'pointer' }} onClick={() => analyze('analyze')} src={isLoading && isLoadingFor === 'analyze' ? analyzingLoading : AnalyzingIcon} alt="..." />
                        </Col>
                        <Col md={1}>
                            <img style={{ height: '20px', cursor: 'pointer' }} onClick={() => setZoom(w => w + 10)} src={ZoomIn} alt="..." />
                        </Col>
                        <Col md={1}>
                            <img style={{ height: '20px', cursor: 'pointer' }} onClick={() => setZoom(w => w >= 1 ? w - 10 : w)} src={ZoomOut} alt="..." />
                        </Col>
                        {(enhancedAnalyzer === 'write' || enhancedAnalyzer === 'both' ) && (
                            <Col md={1}>
                                <img style={{ height: '20px', cursor: 'pointer' }} onClick={() => analyze('analyzerenhanced')} src={isLoading && isLoadingFor === 'analyzerenhanced' ? analyzingLoading : AnalyzingEnhancedIcon} alt="Enhanced Analyzer" />
                            </Col>
                        )}
                    </Row>
                    {data && (
                        <div style={{ marginTop: 20 }}>
                            <div>{`TYPE: ${data.protocol}`}</div>
                            <div style={{ color: data.valid ? 'green' : 'red' }}>
                                {data.valid ? 'Pass' : 'Fail'}
                            </div>
                            {!data.valid && <div>{`Fail Reason: ${data.status}`}</div>}
                            <div>{`Confidence: ${data?.confidence || 0}%`}</div>
                            <a style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setShowDetails(d => !d)}>
                                {showDetails ? 'Hide Details' : 'Show Details'}
                            </a>
                            {showDetails && (
                                <>
                                    <div>
                                        <a
                                            style={{ color: 'blue', cursor: 'pointer' }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(JSON.stringify(data, null, 2));
                                                toast.info('copied');
                                            }}
                                        >
                                            Copy
                                        </a>
                                    </div>
                                    <BootstrapTable
                                        data={data.events || []}
                                        keyField="startms"
                                        columns={[
                                            { dataField: 'tone.tonetype', text: 'Tone Type' },
                                            { dataField: 'tone.tonefreq', text: 'Tone Frequency' },
                                            { dataField: 'startms', text: 'Start ms' },
                                            { dataField: 'endms', text: 'End Ms' },
                                            { dataField: 'lenms', text: 'Length Ms' },
                                            { dataField: 'squelch.thresh', text: 'Squelch Thresh' },
                                            { dataField: 'squelch.msres', text: 'Squelch Ms Response' },
                                        ]}
                                    />
                                </>
                            )}
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button outline color="secondary" onClick={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AnalyzerModal;
